import { get } from "../../api";

const serviceNavListData = headers => get("desktopHeader", headers);
const serviceNavListMDataMobile = () => {};

export { serviceNavListData, serviceNavListMDataMobile };



// WEBPACK FOOTER //
// ./src/stores/NavListStore/services.js